<template>
  <header role="banner">
  <div class="navbar">
    <div class="container">
      <!-- Brand and toggle sit OUTSIDE the <nav> landmark so the logo
           is not announced as "Primary navigation" by screen readers. -->
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle collapsed"
          data-toggle="collapse"
          data-target="#bs-example-navbar-collapse-1"
          :aria-expanded="navOpen ? 'true' : 'false'"
          aria-controls="bs-example-navbar-collapse-1"
          aria-label="Toggle navigation menu"
          @click="navOpen = !navOpen"
        >
          <span aria-hidden="true">Menu</span>
          <span
            class="glyphicon glyphicon-menu-hamburger"
            aria-hidden="true"
          ></span>
        </button>
        <router-link
          to="/"
          class="navbar-brand"
          aria-label="Grow With Stocks - Home"
        >
          <img src="../assets/gws-logo-new.png" alt="Grow With Stocks" class="img-responsive">
        </router-link>
      </div>
      <nav
        class="collapse navbar-collapse"
        id="bs-example-navbar-collapse-1"
        aria-label="Primary"
      >

        <ul class="nav navbar-nav navbar-right">
          <li>
            <router-link
              to="/about"
              data-toggle="collapse"
              data-target=".navbar-collapse.in"
            > About</router-link>
          </li>
          <li>
            <router-link
              to="/#services"
              data-toggle="collapse"
              data-target=".navbar-collapse.in"
            >Services</router-link>
          </li>
          <li>
            <router-link
              to="/#whyUs"
              data-toggle="collapse"
              data-target=".navbar-collapse.in"
            >Why Us ?</router-link>
          </li>
          <li>
            <router-link
              to="/pricing"
              data-toggle="collapse"
              data-target=".navbar-collapse.in"
            >Pricing</router-link>
          </li>
          <li>
            <router-link
              to="/faq"
              data-toggle="collapse"
              data-target=".navbar-collapse.in"
            >FAQ</router-link>
          </li>
          <li>
            <router-link
              to="/contact"
              data-toggle="collapse"
              data-target=".navbar-collapse.in"
            >Contact Us</router-link>
          </li>
          <li>
            <router-link
              to="/valid-upi"
              data-toggle="collapse"
              data-target=".navbar-collapse.in"
            >Valid UPI</router-link>
          </li>
          <!-- <li>
            <router-link
              data-toggle="collapse"
              data-target=".navbar-collapse.in"
              v-if="!user"
              to="/login"
            > Login </router-link>
          </li> -->

          <!-- <li>
            <router-link
              data-toggle="collapse"
              data-target=".navbar-collapse.in"
              v-if="!user"
              class="btn_signup ml-3"
              to="/signup"
            > Sign Up</router-link>
          </li> -->
          <li v-if="user">
            <router-link
              data-toggle="collapse"
              data-target=".navbar-collapse.in"
              to="/myaccount"
            > My Account</router-link>
          </li>
          <li v-if="user && user.admin == 999">
            <router-link
              data-toggle="collapse"
              data-target=".navbar-collapse.in"
              to="/admin"
            > Admin</router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
  </header>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    name: "Header",
    data() {
      return {
        navOpen: false
      };
    },
    computed: {
      ...mapGetters(["user"])
    },
    methods: {
      openDrawer() {
        this.$store.state.drawer = true;
      }
    },
    watch: {
      $route() {
        // Collapse mobile menu when route changes
        this.navOpen = false;
      }
    }
  };
</script>

<style lang="scss">
  .navbar-brand {
    color: #1a7055;
    font-size: 1.8em;
    font-weight: 800;
    border-bottom: none !important;
    padding: 0px 15px !important;
    img {
      height: 45px;
      width: auto;
      max-width: 100%;
    }
  }
  .navbar-header > a:hover {
    color: #0d3d2e;
  }
  .navbar-header > a:visited {
    color: #1a7055;
  }
  .nav > li > a {
    color: #4a4a4a;
    font-weight: 500;
    margin: 0 3px;
  }
  .nav > li > a:focus,
  .nav > li > a:hover {
    background: none;
    color: #1a7055;
    text-decoration: underline;
  }
  .router-link-exact-active {
    border-bottom: 2px solid #1a7055;
  }

  .btn_signup {
    background-color: #1a7055;
    border-radius: 4px;
    margin-left: 10px;
    font-weight: 600 !important;
    padding: 10px 15px !important;
    color: #fff !important;
  }

  .nav > li > .btn_signup:hover {
    background-color: #0d3d2e;
    color: #fff !important;
  }
  .nav > li > .btn_signup:focus {
    background-color: #0d3d2e;
    color: #fff !important;
    outline: 3px solid #ffbf47;
  }

  .navbar-toggle {
    position: relative;
    float: right;
    padding: 9px 10px;
    margin-top: 20px;
    margin-right: 15px;
    margin-bottom: 8px;
    background-color: transparent;
    background-image: none;
    border-radius: 4px;
    span {
      color: #1a7055;
    }
  }
  /*==========  Mobile First Method  ==========*/

  /* Custom, iPhone Retina */
  @media only screen and (min-width: 320px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (min-width: 480px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (min-width: 768px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (min-width: 992px) {
  }

  /* Large Devices, Wide Screens */
  @media only screen and (min-width: 1200px) {
  }

  /*==========  Non-Mobile First Method  ==========*/

  /* Large Devices, Wide Screens */
  @media only screen and (max-width: 1200px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width: 992px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (max-width: 768px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (max-width: 480px) {
    .router-link-exact-active {
      border-bottom: none;
    }
  }

  @media screen and (max-width: 1024px) {
    .nav > li > a {
      margin: 10px 3px;
      padding: 10px 10px;
    }
    .btn_signup {
      margin-top: 8px;
    }
  }

  @media screen and (max-width: 768px) {
    .navbar-brand {
      img {
        height: 35px;
        width: auto;
      }
    }
    .nav > li > a {
      margin: 10px 0px;
      padding: 10px 10px;
      font-size: 12px;
    }
    .btn_signup {
      margin-top: 8px;
      margin-left: 0px;
      padding: 10px 10px !important;
    }
  }
  @media only screen and (max-width: 375px) {
    .navbar-toggle {
      position: relative;
      float: right;
      padding: 9px 10px;
      margin-top: 15px;
      margin-right: 15px;
      margin-bottom: 8px;
      background-color: transparent;
      background-image: none;
      border-radius: 4px;
    }
  }
  /* Custom, iPhone Retina */
  @media only screen and (max-width: 320px) {
    .navbar-toggle {
      position: relative;
      float: right;
      padding: 9px 10px;
      margin-top: 5px;
      margin-right: 15px;
      margin-bottom: 8px;
      background-color: transparent;
      background-image: none;
      border-radius: 4px;
    }
    .navbar-brand {
      max-width: 60%;
      padding-right: 4px !important;
      overflow: hidden;
    }
    .navbar-brand img {
      height: 30px;
      width: auto;
      max-width: 100%;
    }
  }
  /* WCAG 1.4.4/1.4.10 — Prevent logo/menu overlap at 200% zoom on narrow viewports */
  @media only screen and (max-width: 480px) {
    .navbar-brand {
      max-width: calc(100% - 110px);
      padding-right: 6px !important;
      overflow: hidden;
      white-space: nowrap;
    }
    .navbar-brand img {
      max-width: 100%;
      height: auto;
      max-height: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue